import { gql, useMutation } from "@apollo/client";

export const MUTATION_EDIT_HISTORY_LABEL = gql`
  mutation setHistoryLabel($actionId: ID!, $historyLabel: String!) {
    setHistoryLabel(
      input: { actionId: $actionId, historyLabel: $historyLabel }
    ) {
      id
      name
    }
  }
`;

export function useEditHistoryLabelMutation() {
  const [
    editHistoryLabelMutation,
    {
      loading: isLoadingEditHistoryLabelMutation,
      error: errorEditHistoryLabelMutation
    }
  ] = useMutation(MUTATION_EDIT_HISTORY_LABEL);

  return {
    editHistoryLabelMutation,
    isLoadingEditHistoryLabelMutation,
    errorEditHistoryLabelMutation
  };
}
